// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container---1nMBX"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/WelcomeMessageBuilder/style.styl
// module id = /sFR
// module chunks = 89